import { useEffect, useState } from "react";
import axios from "axios";

const API_URL = "https://haaterkaj-backend-1.onrender.com";

// ✅ Helper: resolve image URLs (Cloudinary or local)
const resolveImage = (image) => {
  if (!image) return "";
  return image.startsWith("http") ? image : `${API_URL}${image}`;
};

export default function Products() {
  const [products, setProducts] = useState([]);

  // 🔹 Fetch all products
  useEffect(() => {
    axios
      .get(`${API_URL}/api/seller/all-products`)
      .then((res) => {
        if (res.data.success) setProducts(res.data.products);
      })
      .catch((err) => console.log("Fetch error:", err.response?.data || err.message));
  }, []);

  // 🔹 Open WhatsApp Chat
  const contactSeller = (phone, productName) => {
    if (!phone) return;
    const url = `https://wa.me/91${phone}?text=Hello, I am interested in your product: ${productName}`;
    window.open(url, "_blank");
  };

  return (
    <div className="max-w-6xl mx-auto p-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">

      {products.length > 0 ? (
        products.map((p) => (
          <div
            key={p._id}
            className="border p-4 rounded-xl shadow-lg bg-white hover:shadow-xl transition"
          >
            {/* Product Image */}
            <img
              src={resolveImage(p.image)}
              className="h-48 w-full object-cover rounded-md"
              alt={p.name || "Product"}
            />

            {/* Product Info */}
            <h3 className="font-bold text-xl mt-3 text-amber-800">
              {p.name || "Unnamed Product"}
            </h3>
            <p className="text-gray-600 text-sm italic">
              Origin: {p.place || "Unknown"}
            </p>
            <p className="text-amber-700 font-semibold text-lg mt-2">
              ₹ {p.price || "-"}
            </p>

            {/* Seller Info */}
            {p.seller ? (
              <>
                <p className="text-sm mt-2 text-gray-700">
                  Seller: <span className="font-semibold">{p.seller.name || "Unknown"}</span>
                </p>

                {p.seller.phone ? (
                  <button
                    onClick={() => contactSeller(p.seller.phone, p.name)}
                    className="mt-4 w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition"
                  >
                    Contact Seller on WhatsApp
                  </button>
                ) : (
                  <p className="text-xs text-red-500 mt-2 text-center">
                    Seller has not added phone number yet
                  </p>
                )}
              </>
            ) : (
              <p className="text-sm text-gray-500 mt-2">Seller info not available</p>
            )}
          </div>
        ))
      ) : (
        <h2 className="text-center col-span-3 text-gray-500 text-xl">
          No Seller Products Available
        </h2>
      )}

    </div>
  );
}
